// extracted by mini-css-extract-plugin
module.exports = {"root":"Preloader_root__7cCK5"};